import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { loadingText: String }

  connect() {
    this.originalText = this.element.textContent
  }

  disable() {
    this.element.textContent = this.loadingTextValue || "Lädt ..."
    this.element.setAttribute("aria-disabled", "true")
  }
}
